import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="border-t border-foreground/5 bg-card">
      <div className="mx-auto max-w-[90rem] px-4 py-12">
        <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:grid-cols-5">

          {/* Бренд */}
          <div className="col-span-2 sm:col-span-3 lg:col-span-2">
            <Link to="/" className="text-xl font-semibold tracking-[0.08em] text-foreground">
              FreeApp
            </Link>
            <p className="mt-3 max-w-xs text-sm leading-6 text-foreground/35">
              Магазин игр и подписок для PlayStation, Xbox, Nintendo и других платформ. Быстро, удобно, надёжно.
            </p>
            <div className="mt-5 flex gap-3">
              <a
                href="https://t.me/freeapp"
                target="_blank"
                rel="noreferrer"
                aria-label="Telegram"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-foreground/10 bg-foreground/5 text-foreground/40 transition hover:border-foreground/20 hover:text-foreground"
              >
                <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
                </svg>
              </a>
              <a
                href="mailto:support@freeapp.ru"
                aria-label="Email"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-foreground/10 bg-foreground/5 text-foreground/40 transition hover:border-foreground/20 hover:text-foreground"
              >
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M3 8l7.89 5.26a2 2 0 0 0 2.22 0L21 8M5 19h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2z" />
                </svg>
              </a>
            </div>
          </div>

          {/* О FreeApp */}
          <div>
            <p className="mb-4 text-xs font-semibold uppercase tracking-widest text-foreground/30">О FreeApp</p>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm text-foreground/55 transition hover:text-foreground">
                  О нас
                </Link>
              </li>
              <li>
                <Link to="/catalog" className="text-sm text-foreground/55 transition hover:text-foreground">
                  Каталог игр
                </Link>
              </li>
              <li>
                <Link to="/orders" className="text-sm text-foreground/55 transition hover:text-foreground">
                  Мои заказы
                </Link>
              </li>
            </ul>
          </div>

          {/* Поддержка */}
          <div>
            <p className="mb-4 text-xs font-semibold uppercase tracking-widest text-foreground/30">Поддержка</p>
            <ul className="space-y-3">
              <li>
                <Link to="/support" className="text-sm text-foreground/55 transition hover:text-foreground">
                  Центр помощи
                </Link>
              </li>
              <li>
                <Link to="/contacts" className="text-sm text-foreground/55 transition hover:text-foreground">
                  Контакты
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-sm text-foreground/55 transition hover:text-foreground">
                  Отзывы
                </Link>
              </li>
            </ul>
          </div>

          {/* Документы */}
          <div>
            <p className="mb-4 text-xs font-semibold uppercase tracking-widest text-foreground/30">Документы</p>
            <ul className="space-y-3">
              <li>
                <Link to="/terms" className="text-sm text-foreground/55 transition hover:text-foreground">
                  Пользовательское соглашение
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-foreground/55 transition hover:text-foreground">
                  Политика конфиденциальности
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Нижняя строка */}
        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-foreground/5 pt-6 sm:flex-row">
          <p className="text-xs text-foreground/20">
            © {new Date().getFullYear()} FreeApp. Все права защищены.
          </p>
          <p className="text-xs text-foreground/20">
            Оплата и доставка цифровых товаров мгновенно
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
